import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withTranslation } from 'react-i18next';

import React, { Component } from 'react'
import Slider from "react-slick"

import ObjPushThematiqueFormation from './ObjPushThematiqueFormation'
import { throttle, isMobile } from "../../utilities/FrontFunctions/AoxGlobalFrontFunctions"

import '../../assets/css/0020_objects/0710_obj_carousel_formation.css'
import '../../assets/css/0020_objects/0850_obj_list_pushs_thematique_comptoir_dermato.css'

class ObjListPushsThematiqueComptoirDermato extends Component {
	constructor(props) {
		super(props)
		this.state = {
			isMobile: isMobile(),
		}
		this.handleWindowResizeMainHeader = this.handleWindowResizeMainHeader.bind(this)
		this.throttleWindowResizeMainHeader = throttle(this.handleWindowResizeMainHeader, 200)
	}
	handleWindowResizeMainHeader() {
		this.setState({
			isMobile: isMobile()
		})
	}

	onSwipe() {
        if (this.slider) {
          	this.slider.innerSlider.clickable = true;
        }
	}

    render() {
        const { datasThemes } = this.props;

		const sliderRef = slider => {this.slider = slider}
        const settings = {
            className: "obj_carousel_formation obj_carrousel_slider",
            centerMode: false,
			infinite: false,
			slidesToShow: 3,
            swipeToSlide: true,
            onSwipe: this.onSwipe.bind(this),
            dots: false,
            dotsClass: "slider-nav",
            appendDots: dots => (
                <div className="slider-nav" >
                    <ul> {dots} </ul>
                </div>
            ),
            arrows: true,
            speed: 750,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        centerPadding: "10%",
                        centerMode: true,
                        slidesToShow: 1,
                        dots: true,
                        arrows: false,
                    }
                }
            ]
        }

		return (<>{datasThemes && <>
			<div className="obj_list_pushs_thematique_comptoir_dermato">
				<div className="ctn_title">
					<h2 className="t_title">Choisissez une thématique :</h2>
				</div>

				{ this.state.isMobile &&

					<div className="ctn_carrousel">
						<Slider {...settings} ref={sliderRef}>
                            { datasThemes.map((datasTheme, index) => (
                                <div className="item" key={index}>
                                    <ObjPushThematiqueFormation datasTheme={datasTheme}/>
                                </div>
                            ))}
						</Slider>
					</div>

				}
				
				{!this.state.isMobile &&

					<div className="ctn_carrousel">
						<Slider {...settings} ref={sliderRef}>
                        { datasThemes.map((datasTheme, index) => (
                                <div className="item" key={index}>
                                    <ObjPushThematiqueFormation datasTheme={datasTheme}/>
                                </div>
                            ))}
						</Slider>
					</div>

				}

			</div>
        </>}</>)
	}
}

export default withTranslation()(withSitecoreContext()(ObjListPushsThematiqueComptoirDermato));